import axios from 'axios';
import moment from 'moment-timezone';
import { store } from '../store';

import { fmtEnrollment } from '../common/utils/format';

export function createEnrollment(quoteID, shopper) {
  const token = localStorage.getItem('SessionToken');

  // Prefill out known information for new enrollment
  const { state, zipcode, countyName } = shopper;
  return axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/agent/enrollment/`,
    method: 'post',
    headers: { Authorization: `Token ${token}` },
    data: {
      quote_id: quoteID,
      fields: {
        state,
        zipcode,
        county_name: countyName,
      },
      submitted: false,
    },
  }).then(res => fmtEnrollment(res.data));
}

export function updateEnrollment({ values, submitted = false }) {
  const { quote: { quoteID } } = values;
  const token = localStorage.getItem('SessionToken');
  store.dispatch({ type: 'SET_ENROLLMENT_SAVING', saving: true });
  store.dispatch({ type: 'SET_ENROLLMENT_SAVING_ERROR', error: false });

  const nowWithTz = moment.tz(moment(), moment.tz.guess());

  const data = {
    quote_id: quoteID,
    fields: values,
    submitted_flag: submitted,
    submit_date: submitted ? nowWithTz : null,
  };

  return axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/agent/enrollment/${quoteID}/`,
    method: 'put',
    headers: { Authorization: `Token ${token}` },
    data,
  }).then(res => {
    store.dispatch({ type: 'SET_ENROLLMENT_SAVING', saving: false });
    store.dispatch({ type: 'SET_ENROLLMENT_LAST_SAVED', time: nowWithTz });
    return fmtEnrollment(res.data);
  }).catch(error => {
    store.dispatch({ type: 'SET_ENROLLMENT_SAVING', saving: false });
    store.dispatch({ type: 'SET_ENROLLMENT_SAVING_ERROR', error });
    throw error;
  });
}


export function getEnrollment(quoteID) {
  const token = localStorage.getItem('SessionToken');
  const site = process.env.REACT_APP_HOSTNAME || window.location.hostname;

  return axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/agent/enrollment/${quoteID}/`,
    method: 'get',
    headers: { Authorization: `Token ${token}` },
    params: { site },
  }).then(res => fmtEnrollment(res.data));
}

export function getEnrollmentConfig(carrier, year) {
  const token = localStorage.getItem('SessionToken');
  const formattedCarrierName = carrier.toLowerCase().replaceAll(' ', '-');
  const configName = `enrollment_form_agent_${formattedCarrierName}_${year}_json`;
  return axios({
    method: 'get',
    headers: { Authorization: `Token ${token}` },
    url: `${process.env.REACT_APP_MMB_API_URL}/api/config/name/`,
    params: { name: configName, access: 'public', site: 'ALL_SITES_SITE' },
  }).then((res) => res.data);
}

export function getEnrollmentOptions(type, year) {
  const token = localStorage.getItem('SessionToken');
  let configName = '';
  if (year) {
    configName = `enrollment_form_${type}_${year}_json`;
  } else {
    configName = `enrollment_form_${type}_json`;
  }
  return axios({
    method: 'get',
    headers: { Authorization: `Token ${token}` },
    url: `${process.env.REACT_APP_MMB_API_URL}/api/config/name/`,
    params: { name: configName, access: 'public', site: 'ALL_SITES_SITE' },
  }).then((res) => res.data);
}

function SubmitException(errors, status) {
  this.message = 'There was an error submitting the enrollment';
  this.errors = errors;
  this.status = status;
}

export async function submitEnrollment(quoteID, submitType, submitData) {
  const token = localStorage.getItem('SessionToken');

  let errors = [];

  // oec carriers
  if (submitType.toLowerCase() === 'oec') {
    try {
      const { data } = await axios({
        method: 'post',
        url: `${process.env.REACT_APP_MMB_API_URL}/api/utils/enroll/oec/`, // REMOVED FOR TESTING THE C
        data: submitData,
        headers: { Authorization: `Token ${token}` },
        params: { quote_id: quoteID },
      });

      return fmtEnrollment(data.enrollment);
    } catch (error) {
      let status = 418;
      let errorMessages;

      if (error.response) {
        ({
          status = 418,
          data: {
            errors: errorMessages = [ 'Unable to submit enrollment' ],
          } = {},
        } = error.response);
        errors = [
          `[ERROR ${error.response.status}]: ${errorMessages.join(' ')}.`,
        ];
      }

      throw new SubmitException(errors, status);
    }
  }

  // api carriers
  try {
    const { data } = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_MMB_API_URL}/api/utils/enroll/${submitType}/`,
      data: submitData,
      headers: { Authorization: `Token ${token}` },
      params: { quote_id: quoteID },
    });

    return fmtEnrollment(data.enrollment);
  } catch (error) {
    let status = 418;

    if (error.response) {
      ({ status = 418 } = error.response);
      ({ errors = [] } = error.response.data);
    }

    throw new SubmitException(errors, status);
  }
}
